let store = null;

// This avoids importing getStore from the app, which would introduce a circular
// dependency. Obviously, this is a heinous hack and will be removed.
// The path forward is to move all state management to the ducks pattern.
// Ducks have an initialisation function that can take services such as a
// store provider.
const getStore = () => store;
export const setStore = (newStore) => {
  store = newStore;
};

const getBaseUrl = () => getStore().getState().institution.keys.endpoints.api;
const getBaseUrlV2 = () =>
  getStore().getState().institution.keys.endpoints.apiV2;
const getServiceBaseUrl = () =>
  getStore().getState().institution.keys.endpoints.services;

const getSocketEndPoint = () => (getState) => {
  const state = getState();
  const {
    institution: {
      general: { base_domain: baseDomain },
    },
  } = state;
  return `https://services.${baseDomain}:44300/user`;
};

export const LOGIN_CODE_REQUEST = () => `${getBaseUrlV2()}/auth/login/request`;
export const LOGIN_CODE_VALIDATE = () =>
  `${getBaseUrlV2()}/auth/login/validate`;
export const LOGOUT = () => `${getBaseUrlV2()}/auth/logout`;
export const FETCH_DEVICES = () => `${getBaseUrlV2()}/auth/devices`;

export const CLASSROOM_CODEGEN = () =>
  `${getBaseUrl()}/classroom/code/generate/`;
export const CLASSROOM_ROLES_ADD = () => `${getBaseUrl()}/classroom/role/add`;
export const CLASSROOM_ROLES_REMOVE = () =>
  `${getBaseUrl()}/classroom/role/remove`;

export const CLASSROOM_MATERIAL_FOLDERS = (classRoomId) =>
  `${getBaseUrlV2()}/materials/spaces/${classRoomId}/material/folders`;
export const CLASSROOM_MATERIAL_FOLDER = (classRoomId, folderId) =>
  `${getBaseUrlV2()}/materials/spaces/${classRoomId}/material/folders/${folderId}`;
export const CLASSROOM_MATERIAL_SECTIONS = (classRoomId) =>
  `${getBaseUrlV2()}/materials/spaces/${classRoomId}/material/sections`;
export const CLASSROOM_MATERIAL_SECTION = (classRoomId, sectionId) =>
  `${getBaseUrlV2()}/materials/spaces/${classRoomId}/material/sections/${sectionId}`;
export const CLASSROOM_MATERIAL_SECTION_VERSIONS = (classRoomId, sectionId) =>
  `${getBaseUrlV2()}/materials/spaces/${classRoomId}/material/sections/${sectionId}/versions`;
export const CLASSROOM_MATERIAL_SECTION_VERSION = (classRoomId, sectionId) =>
  `${getBaseUrlV2()}/materials/spaces/${classRoomId}/material/sections/${sectionId}/version`;

export const REQUEST_FAVICON = (url) =>
  `${getBaseUrl()}/image/favicon?url=${url}`;

export const INBOX_CONVERSATIONS = () => `${getBaseUrlV2()}/conversations`;
export const INBOX_CONVERSATION = (conversationId) =>
  `${getBaseUrlV2()}/conversations/${conversationId}`;
export const INBOX_CONVERSATION_MESSAGES = (conversationId) =>
  `${getBaseUrlV2()}/conversations/${conversationId}/messages`;
export const INBOX_MESSAGE = (conversationId, messageId) =>
  `${getBaseUrlV2()}/conversations/${conversationId}/messages/${messageId}`;
export const INBOX_PARTICIPATION = (conversationId, participantId) =>
  `${getBaseUrlV2()}/conversations/${conversationId}/participants/${participantId}`;

export const CHANGE_AVATAR = () => `${getBaseUrl()}/user/avatar/upload/`;
export const STARTUP_DATA = () => `${getBaseUrlV2()}/startup`;
export const FETCH_FEED = ({
  spaceId,
  until,
  after,
  tagId,
  important,
  scheduled,
}) =>
  `${getBaseUrlV2()}/posts/feed?space=${spaceId}${
    until ? `&until=${until.toISOString()}` : ''
  }${after ? `&after=${after.toISOString()}` : ''}${
    tagId ? `&tag=${tagId}` : ''
  }${important ? '&important=true' : ''}${scheduled ? '&scheduled=true' : ''}`;
export const FETCH_IMPORTANT_POSTS = (spaceId, until) =>
  `${getBaseUrlV2()}/posts/important?space=${spaceId}&until=${until.toISOString()}`;
export const ELASTICSEARCH = () => `${getBaseUrl()}/search`;
export const SEARCH = () => `${getBaseUrlV2()}/search`;
export const ANALYTICS = () => `${getBaseUrlV2()}/analytics`;
export const USERS = () => `${getBaseUrlV2()}/users`;
export const USER = (userId) => `${getBaseUrlV2()}/users/${userId}`;
export const LTI_PROVIDERS = () => `${getBaseUrlV2()}/lti/providers`;
export const LTI_CONSUMER = () => `${getBaseUrlV2()}/lti-consumer`;
export const LTI_LAUNCHFORM = () => `${getBaseUrlV2()}/lti-launchform`;
export const BBB_LTI_CONSUMER = () => `${getBaseUrlV2()}/bbb-lti-consumer`;
export const BIBLIU_LTI_CONSUMER = () =>
  `${getBaseUrlV2()}/bibliu-lti-consumer`;
export const TALIS_LTI_CONSUMER = () => `${getBaseUrlV2()}/talis-lti-consumer`;
export const ECHO_LTI_CONSUMER = () => `${getBaseUrlV2()}/echo-lti-consumer`;
export const PLANET_LTI_CONSUMER = () =>
  `${getBaseUrlV2()}/planet-lti-consumer`;
export const PANOPTO_LTI_CONSUMER = () =>
  `${getBaseUrlV2()}/panopto-lti-consumer`;
export const WEBSOCKET_ENDPOINT = getSocketEndPoint();

export const ENGAGEMENT_ANALYTICS = () => `${getBaseUrlV2()}/engagement`;
export const ENGAGEMENT_DASHBOARD = () => `${ENGAGEMENT_ANALYTICS()}/dashboard`;

export const ASSIGNMENT = () => `${getServiceBaseUrl()}/assignments`;
export const AULA_ASSIGNMENTS = () => `${getBaseUrlV2()}/assignments`;

export const SUBMISSIONS = (assignmentId) =>
  `${getBaseUrlV2()}/assignments/${assignmentId}/submissions`;

export const ACCESS_TOKEN_ENDPOINT = (spaceId) =>
  `${getBaseUrlV2()}/users/authorize?aud=handin&scope=space_${spaceId}`;
export const FILE_UPLOADER_V2 = () => `${getBaseUrlV2()}/file/upload`;

export const POST = (postId) => `${getBaseUrlV2()}/posts/${postId}`;
export const POSTS = (spaceId) => `${getBaseUrlV2()}/posts?space=${spaceId}`;
export const POST_COMMENTS = (postId) =>
  `${getBaseUrlV2()}/posts/${postId}/comments`;
export const POST_COMMENT = ({ postId, commentId }) =>
  `${getBaseUrlV2()}/posts/${postId}/comments/${commentId}`;

export const TAGS = (spaceId) => `${getBaseUrlV2()}/spaces/${spaceId}/tags`;
export const POST_TAG = ({ postId, tagId }) =>
  `${getBaseUrlV2()}/posts/${postId}/tags/${tagId}`;

export const GET_SPACE = ({ spaceId }) =>
  `${getBaseUrlV2()}/spaces/${spaceId}?educators=true`;
export const SPACE_PARTICIPANTS = ({
  spaceId,
  skip = 0,
  sort = 'lastName',
  limit = 100,
  role,
}) =>
  `${getBaseUrlV2()}/spaces/${spaceId}/participants?limit=${limit}&skip=${skip}&sort=${sort}${
    role ? `&role=${role}` : ''
  }`;
export const ADD_PARTICIPANT_TO_SPACE = (spaceId) =>
  `${getBaseUrlV2()}/spaces/${spaceId}/participants`;
export const SPACE_PARTICIPANTS_HISTORY = ({
  spaceId,
  before = new Date().toISOString(),
  limit = 50,
}) =>
  `${getBaseUrlV2()}/spaces/${spaceId}/participants/history?before=${before}&limit=${limit}`;
export const REMOVE_PARTICIPANT_FROM_SPACE = (spaceId, userId) =>
  `${getBaseUrlV2()}/spaces/${spaceId}/participants/${userId}`;
export const SPACE = (spaceId) => `${getBaseUrlV2()}/spaces/${spaceId}`;

export const GROUP_SETS = ({ setId, spaceId }) => {
  const query = spaceId ? `?space=${spaceId}` : '';
  const set = setId ? `/${setId}` : '';
  return `${getBaseUrlV2()}/groups/sets${set}${query}`;
};
export const GROUP_SET = (setId) => `${getBaseUrlV2()}/groups/sets/${setId}`;
export const GROUP_GROUPS = () => `${getBaseUrlV2()}/groups/groups`;
export const GROUP_GROUP = (groupId) =>
  `${getBaseUrlV2()}/groups/groups/${groupId}`;
export const GROUP_GENERATE = (setId) =>
  `${getBaseUrlV2()}/groups/sets/${setId}/generate`;

export const BIG_BLUE_BUTTON = ({ id, context }) =>
  `${getBaseUrlV2()}/bigbluebutton/join/${context}/${id}`;

export const REACTIONS = () => `${getBaseUrlV2()}/reactions`;
export const REACTION = (reactionId) =>
  `${getBaseUrlV2()}/reactions/${reactionId}/user`;

export const NOTIFICATION_SETTINGS = () =>
  `${getBaseUrlV2()}/notifications/settings`;

export const NOTIFICATIOS = () => `${getBaseUrlV2()}/notifications`;

export const FILE_AUTH_COOKIE = (body) =>
  `${getBaseUrlV2()}/file/cookie?${body ? 'body=true' : ''}`;
